import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mt-4 pt-1" }

import Dialog from "@/components/ui/Modal/Dialog/Dialog.vue";
import {computed, PropType, ref} from "vue";
import {ILocationPackage} from "@/api/services/packages/esim/location-packages/types";
import SelectPackage from "@/components/User/SelectPackage.vue";
import AppButton from "@/components/ui/Buttons/AppButton.vue";
import AppInput from "@/components/Form/AppInput.vue";
import {api} from "@/api/Api";
import {useStore} from "vuex";
import {IApiResponse} from "@/api/interfaces/IApi";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddUserEsim',
  props: {
  opened: {type: Boolean, default: false},
  canCancel: {type: Boolean, default: false},
  plans: {
    type: Object as PropType<ILocationPackage[]>,
    required: true
  },
  currentPackage: {
    type: Object as PropType<number | null>
  },
  userId: {
    type: Number as PropType<number>,
    required: true
  }
},
  emits: {
  hide: null,
  changePackage: null,
  refetch: null
},
  setup(__props, { emit }) {

const props = __props;

const currentEsim = ref<number | null>(null)
const store = useStore()

function changePackage(id: number) {
  currentEsim.value = id
}

const profileName = ref<string>('')

const validation = computed<boolean>(() =>
    currentEsim.value !== null
      && profileName.value.length >= 3
      && profileName.value.length <= 32
)





async function baseRequestHandler(promise: Promise<IApiResponse> ) {
  try {
    const {success, message} = await promise;
    if (!success) {
      throw new Error(message);
    }
    await store.dispatch("showSuccessNotification", 'Success');
    emit('refetch');
    emit('hide');
  } catch (e: any) {
    await store.dispatch("showErrorNotification", e.message);
  }
}

const loading = ref<boolean>(false)

async function submit(): Promise<void> {
  const data = {
    userId: props.userId,
    packageId: currentEsim.value,
    profileName: profileName.value
  }

  console.table({addSubmit: data})
  if (!currentEsim.value) {
    return
  }

  const func: Promise<IApiResponse> = api.addEsimWithPackageForUser(profileName.value, currentEsim.value, props.userId)
  await baseRequestHandler(func)
}

function hide() {
  emit('hide')
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Dialog, _mergeProps({
    title: "Add esim",
    opened: __props.opened
  }, _ctx.$attrs, { onHide: hide }), {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createVNode(SelectPackage, {
          plans: __props.plans,
          onChangePackage: changePackage
        }, null, 8, ["plans"]),
        _createVNode(AppInput, {
          id: "profileInput",
          modelValue: profileName.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((profileName).value = $event)),
          label: "Profile Name",
          "input-type": "material",
          disabled: false
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(AppButton, {
            type: "secondary",
            size: "xl",
            disabled: !_unref(validation),
            loading: loading.value,
            onClick: submit
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Confirm ")
            ]),
            _: 1
          }, 8, ["disabled", "loading"])
        ])
      ], 32)
    ]),
    _: 1
  }, 16, ["opened"]))
}
}

})